import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SearchContainer = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 4px 8px;
  background-color: #ffffff;
  gap: 6px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
  min-width: 0;

  &::placeholder {
    color: #aaaaaa;
  }
`;

const SearchIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: gray;
`;

const SearchBar = forwardRef(
  (
    {
      placeholder = 'Pesquisar por nome',
      value,
      defaultValue,
      onChange,
      name,
      className,
      inputProps = {},
      ...containerProps
    },
    ref
  ) => {
    return (
      <SearchContainer className={className} {...containerProps}>
        <SearchInput
          ref={ref}
          type="text"
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          name={name}
          {...inputProps}
        />
        <SearchIcon className="material-symbols-outlined" aria-hidden="true">
          search
        </SearchIcon>
      </SearchContainer>
    );
  }
);

SearchBar.displayName = 'SearchBar';

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};

export default SearchBar;

